'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './payment-plan-edit.routes';

export class PaymentPlanEditComponent {
  /*@ngInject*/
  constructor(dialogs, BankingAccountsService, RecurringPaymentsService, $stateParams, $state, $location, Auth, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.BankingAccountsService = BankingAccountsService;
    this.RecurringPaymentsService = RecurringPaymentsService;
    this.Auth = Auth;
    this.recurringPaymentId = $stateParams.id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;

    this.frequencies = [{
      name: "Every Month",
      value: "1m"
    }, {
      name: "Every Two Months",
      value: "2m"
    }, {
      name: "Every Three Months",
      value: "3m"
    }, {
      name: "Every Six Months",
      value: "6m"
    }, {
      name: "Every Year",
      value: "1y"
    }];

    this.recurringPayment = {
      user: Auth.getCurrentUserSync()._id,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id
      }
    };

    if (this.recurringPaymentId) {
      this.RecurringPaymentsService.get({id: this.recurringPaymentId}, recurringPayment => {
        this.recurringPayment = recurringPayment;
        this.recurringPayment.startDate = new Date(recurringPayment.startDate);
      }, err => {
        console.log('Could not get the recurring payment from the server.');
      });
    }

    this.BankingAccountsService.getByUser({id: Auth.getCurrentUserSync()._id}, bankingAccounts => {
      this.bankingAccounts = bankingAccounts.map(bankingAccount => {
        let name = bankingAccount.name;
        if (!bankingAccount.status !== 'verified') {
          name += " (Unverified)";
        }
        return {
          name: name,
          id: bankingAccount._id
        }
      });
    }, err => {
      console.log('Could not get the banking accounts from the server.');
    });

    this.submitted = false;
  }

  create(form) {
    var that = this;
    /*
    if (!this.bankingAccount.name || this.bankingAccount.name.trim() == '') {
      this.dialogs.error("Name your Account", "You must enter a name for the account");
      return;
    }

    if (!this.bankingAccount.accountHolder || this.bankingAccount.accountHolder.trim() == '') {
      this.dialogs.error("Account Holder Name", "You must enter the account holder's name");
      return;
    }

    if (!this.bankingAccount.routingNumber || this.bankingAccount.routingNumber.trim() == '') {
      this.dialogs.error("Routing Number", "You must enter a valid routing number");
      return;
    }

    if (!this.bankingAccount.accountNumber || this.bankingAccount.accountNumber.trim() == '') {
      this.dialogs.error("Account Number", "You must enter a valid account number");
      return;
    }
*/
    var onSuccess = () => {
      that.submitted = false;

      var actionString = (that.bankingAccountId) ? "changed" : "created";
      var dlg = that.dialogs.notify("Success", "Your recurring payment has been "+actionString+" successfully");
      dlg.result.then(() => {
        that.$state.go("payment-plan-list");
      });
    };

    var onError = err => {
      that.sendFailure = true;
    };

    if (this.recurringPaymentId) {
      this.RecurringPaymentsService.update({id: this.recurringPaymentId}, this.recurringPayment, onSuccess, onError);
    } else {
      this.RecurringPaymentsService.save(this.recurringPayment, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.paymentPlanEdit', [uiRouter])
  .config(routes)
  .component('paymentPlanEdit', {
    template: require('./payment-plan-edit.html'),
    controller: PaymentPlanEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/payment/plan-edit/payment-plan-edit.component.js